import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Route } from '../../../class/route';
import { RouteService } from '../../../service/route/route.service';
import { TranslateService } from '@ngx-translate/core';
import { MapsAPILoader } from '@agm/core';
import { Marker } from '../../../../../interfaces/marker';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';

@Component({
  selector: 'app-new-route',
  templateUrl: './new-route.component.html',
  styleUrls: ['./new-route.component.scss']
})
export class NewRouteComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: Route;
    public promiseForm: Promise<any>;
    public form: FormGroup;
    public name: AbstractControl;
    public description: AbstractControl;
    public stations: AbstractControl;
    public employee_id: AbstractControl;
    public employeeSelected: string;
    public activated: AbstractControl;

    public employeePositionToEmployeeAuxiliar: string;
    public save_exit: boolean;

    public employeePositionToLoad: string;

    constructor(
        fb: FormBuilder,
        public routeService: RouteService,
        public translate: TranslateService,
        private ngZone: NgZone,
        private notificationsService: NotificationsService,
        private mapsAPILoader: MapsAPILoader) {


        this.employeePositionToEmployeeAuxiliar = '2';
        this.save_exit = false;

        this.employeePositionToLoad = '2';

        this.form = fb.group({
            'name': ['', Validators.compose([Validators.required, Validators.minLength(2)])],
            'description': ['', Validators.compose([Validators.minLength(2)])],
            'stations': [''],
            'employee_id': [''],
            'activated': ['', Validators.compose([Validators.required])],
        });

        this.name = this.form.controls['name'];
        this.description = this.form.controls['description'];
        this.stations = this.form.controls['stations'];
        this.employee_id = this.form.controls['employee_id'];
        this.activated = this.form.controls['activated'];
    }

    ngOnInit() {
        if (this.edit) {
            this.name.setValue(this.edit.name);
            this.description.setValue(this.edit.description);
            let stations = [];
            this.edit.stations.forEach(element => {
              stations.push({'label': element.name, 'value': element.id})
            });
            this.stations.setValue(stations);
            this.employee_id.setValue(this.edit.employee);
            this.activated.setValue(this.edit.activated);
        } else {
            this.activated.setValue(true);
        }
    }

    public cancelRoute () {
        console.log('reset');
        this.form.reset();
        this.close.emit(true);
    }

    public saveandexit (values){
        this.save_exit = true;
        this.newRoute(values);
    }

    public newRoute(values) {
        const stations = [];
        if (values.stations !== '') {
            values.stations.forEach(element => {
                if (element.value) {
                    stations.push(element.value);
                }
            });
        }

        const param = {
            'name': values.name,
            'description': values.description,
            'stations': stations,
            'employee_id': values.employee_id.id,
            'activated': values.activated,
        };
        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.routeService.updateRoute(this.edit.id, param)
                :
                this.routeService.newRoute(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        if (this.save_exit) {
                            this.close.emit(true);
                            this.form.reset();
                            this.save_exit = false;
                        }
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/routes/new-route/new-route.component.ts